export enum ComponentType {
    Widgets,
    Publishers
}
